/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetCardAccountTransactionsResponseTransactionsItemEntryType = typeof GetCardAccountTransactionsResponseTransactionsItemEntryType[keyof typeof GetCardAccountTransactionsResponseTransactionsItemEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountTransactionsResponseTransactionsItemEntryType = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
